/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { END } from 'redux-saga';
import {
    put, fork, call, takeEvery, select, take,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import { trackEvent } from '../../../TagManager/ducks/TagManager/TagManager-Actions';
import { recipientFormFields } from '../RecipientForm/RecipientForm-Helpers';
import {
    cardIsleAvailable,
    loadCardIsle,
    addCardIsle,
    addCardIsleComplete,
    enterpriseAddCardIsle,
    generateCardtoCardIsleCompleted,
    // resetCardIsle,
} from './CardIsle-Actions';
import { loadError } from '../../../Common/ducks/Error/Error-Actions';
import {
    getUserSubmittedProductFilterZipcode, getOrderId,
} from '../../../Common/Common-Selectors';
import { getCardIsleSelected } from './CardIsle-Selector';
import orderClient from '../../../../../apis/checkout-apis/orderClient';
import { checkJWT } from '../../../Member/ducks/Auth/Auth-Operations';
import { retrieveCart } from '../../../MfeCheckout/ducks/Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { getBrand, getFeatureFlags } from '../../../Checkout/ducks/Global/Global-Selectors';
import { getIsPassportUserLoggedIn, getMemberLoyalty } from '../../../Member/ducks/Common/Common-Selectors';
import getPriceFromEngine from '../../../../../apis/product-apis/priceEngine';
import { getCartOrder } from '../../../MfeCheckout/ducks/Cart/Cart-Selectors';
import { processFeatureErrors } from '../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';
import { prepareRetreiveCart } from '../../../MfeCheckout/ducks/Cart/ducks/RetrieveCart/PrepareRetreiveCart-Operations';
import { callHandleCartFailure } from '../../../MfeCheckout/ducks/Cart/Cart-Actions';
import { clearOrderItemErrors } from '../../../Checkout/ducks/Common/ducks/Error/Error-Actions';

// empty space is used to avoid card isle print - no card message
// this happens when user does not add message on card isle window

const getGreetingAvailability = ({
    jwtToken,
    productCode,
    brandCode,
    zipCode,
    locationType,
    deliveryDate,
}) => orderClient.getGreetingAvailability({
    jwtToken,
    productCode,
    brandCode,
    zipCode,
    locationType,
    deliveryDate,
});

function* loadCardIsleAvailable() {
    console.log('loadCardIsleAvailable - 2');
    try {
        const [orderItemToEdit] = yield select(getCartOrder);

        if (orderItemToEdit && orderItemToEdit.recipientAddress) {
            const [cartItems] = orderItemToEdit.cartItems;
            const { product } = cartItems;
            const brandCode = product.brandCode || '';

            let productCode = product.productCode || '';
            if (productCode?.indexOf('-') >= 0) {
                productCode = productCode.split('-');
                productCode = productCode[productCode.length - 1];
            }

            const currentDate = cartItems?.deliveryInfo?.deliveryDate ? new Date(cartItems.deliveryInfo.deliveryDate) : null;
            if (currentDate) {
                const currentDay = (`0${currentDate.getDate()}`).slice(-2);
                const currentMonth = (`0${currentDate.getMonth() + 1}`).slice(-2);

                const deliveryDate = currentDate ? `${currentMonth}/${currentDay}/${currentDate.getFullYear()}` : null;

                const pdpZipCode = yield select(getUserSubmittedProductFilterZipcode);
                const recipientFormData = recipientFormFields(orderItemToEdit.recipientAddress);

                if (recipientFormData && (cartItems?.itemInfo?.zipCode || recipientFormData.zipCode) && recipientFormData.locationType) {
                    const jwtToken = yield call(checkJWT);
                    const configObj = {
                        jwtToken,
                        productCode,
                        brandCode,
                        zipCode: recipientFormData.zipCode || cartItems.zipCode || pdpZipCode,
                        locationType: recipientFormData.locationType || 'Residence',
                        deliveryDate,
                    };

                    const response = yield call(getGreetingAvailability, configObj);
                    yield put(loadCardIsle(response.data));

                    // Track Card Isle Impression - Available
                    if (response.data?.available) {
                        const taggingCardIsle = {
                            eventCategory: 'Checkout',
                            eventAction: 'Card Isle',
                            eventLabel: 'Impression',
                        };
                        yield put(trackEvent(taggingCardIsle));
                    }
                }
            } else {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    module: 'mbp-pwa-ui',
                    function: 'loadCardIsleAvailable',
                    currentDate,
                    message: 'Failed in getting cardIsle availability',
                });
                yield put(loadError({
                    errType: 'cardIsle',
                    errMsg: 'We are sorry, there seems to be a technical issue with cardIsle delivery date, please try again later or use alternate payment method to complete order',
                }));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'loadCardIsleAvailable',
            jsError: ex,
            message: 'Failed in getting cardIsle availability',
        });
        yield put(loadError({
            errType: 'cardIsle',
            errMsg: 'We are sorry, there seems to be a technical issue with cardIsle payment method, please try again later or use alternate payment method to complete order',
        }));
    }
}

function* loadCardIsleAvailableWatcher() {
    yield takeEvery(cardIsleAvailable().type, loadCardIsleAvailable);
}

// TODO: Investigate if it is called in some place which flow
// i think is version enterprise1 but we dont sure if the plans of
// business is active this again.
function* addCardIsleToCart(orderItemId, recipientFormData) {
    try {
        const [orderItemToEdit] = yield select(getCartOrder);
        const cardIsleSelected = yield select(getCardIsleSelected);
        if (
            orderItemToEdit && orderItemToEdit.cartItems
            && cardIsleSelected && cardIsleSelected.pickupCode
        ) {
            const [cartItems] = orderItemToEdit.cartItems;

            const { product } = cartItems;
            const brandCode = product.brandCode || '';
            const cartId = yield select(getOrderId);
            const zipCode = cartItems.zipCode || recipientFormData.zipCode || '';

            if (recipientFormData && zipCode && recipientFormData.locationType) {
                const jwtToken = yield call(checkJWT);

                let skuCI = cardIsleSelected.productCode;
                if (skuCI?.indexOf('-') >= 0) {
                    skuCI = skuCI.split('-');
                    skuCI = skuCI[skuCI.length - 1];
                }

                const payload = {
                    env: {},
                    jwtToken,
                    cartItemId: orderItemId,
                    brandCode,
                    sku: skuCI, // card isle product code
                    greetingCardKey: cardIsleSelected.pickupCode,
                    greetingMessage: cardIsleSelected.textMessage || ' ',
                    greetingCardName: cardIsleSelected.name,
                    greetingCardImage: cardIsleSelected.img,
                    greetingCardType: 'CI',
                    greetingThumbNail: cardIsleSelected.img || '',
                    cartId,
                };

                // Review the product has card isle available.
                yield call(cartServiceClient.addGreetingCard, payload);
                yield put(addCardIsleComplete());

                // Tagging for save cardisle
                const taggingCardIsle = {
                    eventCategory: 'Checkout',
                    eventAction: 'Card Isle',
                    eventLabel: `${cardIsleSelected.name}|${cardIsleSelected.textMessage}`,
                };
                yield put(trackEvent(taggingCardIsle));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'loadCardIsleAvailable',
            jsError: ex,
            message: 'Failed in getting cardIsle availability',
        });
        yield put(loadError({
            errType: 'cardIsle',
            errMsg: 'We are sorry, there seems to be a technical issue with cardIsle payment method, please try again later or use alternate payment method to complete order',
        }));

        yield put(callHandleCartFailure(ex));

        yield fork(processFeatureErrors, {
            data: {
                orderItemId,
                errorFeatureType: 'giftMessage',
                errorValues: ex.response?.data,
            },
        });
    }
}

function* addCardIsleToCartWatcher() {
    let action = yield take(addCardIsle().type);
    while (action !== END) {
        yield fork(addCardIsleToCart, action.orderItemId, action.recipientFormData);
        action = yield take(addCardIsle().type);
    }
}

// TODO: Investigate if it is called in some place which flow
function* enterpriseAddCardIsleToCart(action) {
    const {
        orderItem, recipientAddress, cardIsleSelected, closeGreeting,
    } = action;

    try {
        if (
            orderItem
            && orderItem.product
            && recipientAddress.locationType
            && cardIsleSelected.pickupCode
        ) {
            const { product } = orderItem;
            const brandCode = product.brandCode || '';
            const cartId = yield select(getOrderId);

            const jwtToken = yield call(checkJWT);

            let skuCI = cardIsleSelected.productCode;
            if (skuCI?.indexOf('-') >= 0) {
                skuCI = skuCI.split('-');
                skuCI = skuCI[skuCI.length - 1];
            }

            const greetingCartPayload = {
                env: {},
                jwtToken,
                cartItemId: orderItem?.cartItemId || '',
                brandCode,
                sku: skuCI, // card isle product code
                greetingCardKey: cardIsleSelected.pickupCode,
                greetingMessage: cardIsleSelected.textMessage || ' ',
                greetingCardName: cardIsleSelected.name,
                greetingCardImage: cardIsleSelected.img,
                greetingCardType: 'CI',
                greetingThumbNail: cardIsleSelected.img || '',
                cartId,
            };

            // Loyalty
            let priceRules = null;
            let priceRulesResponse = {};
            const flags = yield select(getFeatureFlags);

            if (flags['is-loyalty-greeting-card-enabled'] && cardIsleSelected.productCode) {
                const loyaltyStatus = yield select(getMemberLoyalty);
                const passportUser = yield select(getIsPassportUserLoggedIn);

                let partNumber = cardIsleSelected.productCode;
                if (!partNumber.includes('-')) {
                    partNumber = `${brandCode}-${cardIsleSelected.productCode}`;
                }
                const payload = {
                    jwtToken,
                    products: [{ partNumber }],
                    variants: [],
                };

                if (loyaltyStatus && passportUser) {
                    payload.variants.push(
                        {
                            name: 'LOYALTY_TYPE',
                            value: loyaltyStatus.toUpperCase(),
                        },
                        {
                            name: 'CUSTOMER_TYPE',
                            value: 'PASSPORT',
                        },
                    );
                }

                if (payload.variants.length > 0) {
                    priceRulesResponse = yield call(getPriceFromEngine, {}, jwtToken, payload, false);

                    if (priceRulesResponse?.data?.products?.[0]?.priceRules) {
                        priceRules = priceRulesResponse.data.products[0].priceRules;
                    }
                }

                if (priceRules?.length > 0) {
                    greetingCartPayload.priceRules = priceRules;
                }
            }

            // Review the product has card isle available.
            yield call(cartServiceClient.addGreetingCard, greetingCartPayload);
            yield put(addCardIsleComplete());

            yield call(closeGreeting, false);

            // Get Cart
            yield call(retrieveCart);

            // Tagging for save cardisle
            yield put(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Card Isle',
                eventLabel: `${cardIsleSelected.name}|${cardIsleSelected.textMessage}`,
            }));

            if (flags['is-loyalty-greeting-card-enabled'] && greetingCartPayload.priceRules) {
                // Tagging for loyalty personalized card
                yield put(trackEvent({
                    eventCategory: 'Checkout',
                    eventAction: 'Add to cart',
                    eventLabel: 'Personalized Card - Giftastic',
                }));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'CardIsle-Operation',
            function: 'loadCardIsleAvailable',
            jsError: ex,
            message: 'Failed in adding enterprise Card Isle to Cart',
        });

        yield put(callHandleCartFailure(ex));

        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action.data.orderItemId,
                errorFeatureType: 'giftMessage',
                errorValues: ex.response?.data,
            },
        });

        yield put(loadError({
            errType: 'cardIsle',
            errMsg: 'We are sorry, there seems to be a technical issue with cardIsle payment method, please try again later or use alternate payment method to complete order',
        }));
    }
}

function* enterpriseAddCardIsleToCartWatcher() {
    let action = yield take(enterpriseAddCardIsle().type);
    while (action !== END) {
        yield fork(enterpriseAddCardIsleToCart, action);
        action = yield take(enterpriseAddCardIsle().type);
    }
}

// TODO: clean up above functions is the ab is finished for isUniversalV2Enabled
function* getLoyaltyPriceRules(productCode, brandCode) {
    // Loyalty
    let priceRules = null;
    let priceRulesResponse = {};

    try {
        const featureFlags = yield select(getFeatureFlags);
        const jwtToken = yield call(checkJWT);

        if (featureFlags['is-loyalty-greeting-card-enabled'] && productCode) {
            const loyaltyStatus = yield select(getMemberLoyalty);
            const passportUser = yield select(getIsPassportUserLoggedIn);

            let partNumber = productCode;
            if (!partNumber.includes('-')) {
                partNumber = `${brandCode}-${productCode}`;
            }

            const payload = {
                jwtToken,
                products: [{ partNumber }],
                variants: [],
            };

            if (loyaltyStatus && passportUser) {
                payload.variants.push(
                    {
                        name: 'LOYALTY_TYPE',
                        value: loyaltyStatus.toUpperCase(),
                    },
                    {
                        name: 'CUSTOMER_TYPE',
                        value: 'PASSPORT',
                    },
                );
            }

            if (payload.variants.length > 0) {
                priceRulesResponse = yield call(getPriceFromEngine, {}, jwtToken, payload, false);

                if (priceRulesResponse?.data?.products?.[0]?.priceRules) {
                    priceRules = priceRulesResponse.data.products[0].priceRules;
                }
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'CardIsle-Operation',
            function: 'getLoyaltyPriceRules',
            jsError: ex,
            message: 'Failed get loyalty Price Rules',
        });
    }
    return priceRules;
}

// Calling the API to send the greeting card on card isle sy
function* sendGreetingCardDataToCardIsle(action) {
    const greetingData = action.greetingData;
    const cardIsleSelected = greetingData.data;
    const brandCode = greetingData.brandCode;
    const jwtToken = yield call(checkJWT);
    const cartId = yield select(getOrderId);

    let skuCI = cardIsleSelected.productCode;
    if (skuCI?.indexOf('-') >= 0) {
        skuCI = skuCI.split('-');
        skuCI = skuCI[skuCI.length - 1];
    }

    try {
        const brand = yield select(getBrand);
        const primaryBrand = brand?.domain || '1800flowers';
        const cardObj = {
            cardId: '',
            sku: `${brandCode}-${skuCI}`,
            parentSku: '',
            orientation: 'VERTICAL',
            frontView: {
                imagePosition: 'Center',
                imageOverlayText: '',
                overlayTextFontFamily: '',
                overlayTextSize: '',
                overlayTextAlignment: '',
                displayImageUrl: cardIsleSelected.img,
                printImageUrl: cardIsleSelected.img,
            },
            innerView: {
                messagefontFamily: '',
                messageFontSize: '',
                messageFontColor: '',
                messageAlignment: '',
                messageBody: cardIsleSelected.textMessage,
                messageImage: '',
                occasion: greetingData?.data?.occasionDetails?.name || '',
                signature: '-',
            },
            backView: {
                copyRightMessage: '© 1-800-Flowers.com, Inc., Jericho, NY Family of Brands.\nAll Rights Reserved.\n\n 1-800-Flowers.com, Inc is not responsible for and has not\napproved the messaging on the inside of this card.',
                brandLogoUrl: 'https://images.contentstack.io/v3/assets/blt30c54ce2f1d1abb9/bltecb199f96dc6432b/64a3291bad2e9fa0bb00073d/GCI_Card_Back_AllBrands.png',
            },
        };

        const generateCardResponse = yield call(cartServiceClient.sendGreetingCardToCardIsle, {
            wcEnv: {},
            jwtToken,
            cartId,
            cartItemId: action.orderItemId,
            cardTemplate: 'VERTICAL',
            cardType: 'CI',
            card: cardObj,
            primaryBrand,
            keyId: cardIsleSelected.pickupCode,
        });

        mbpLogger.logInfo({
            function: 'sendGreetingCardToCardIsle',
            appName: process.env.npm_package_name,
            module: 'CardIsle-Operation.js',
            message: `Generating Card to Card Isle Success - cartId: ${cartId} - result: ${JSON.stringify(generateCardResponse.data)}`,
            response: generateCardResponse,
        });
    } catch (ex) {
        console.error('GenerateCardtoCardIsle Failed', {
            response: ex.response,
            cartId,
            orderItemId: action.orderItemId,
            sku: skuCI,
        });

        const errorObj = {
            ...ex.response,
            config: ex.response?.config?.data ? JSON.stringify(ex.response.config.data) : ex.response?.config,
            data: ex.response?.data ? JSON.stringify(ex.response.data) : ex.response?.data,
        };

        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'CardIsle-Operation.js',
            function: 'generateCardtoCardIsle',
            jsError: ex,
            errorMessage: errorObj,
            message: `Generating Card to Card Isle Failed - ${cartId} - orderItemId: ${action.orderItemId} - sku: ${skuCI}`,
            orderId: cartId,
        });
    }
    yield put(generateCardtoCardIsleCompleted());
}

// Version Checkout Universal checkout use
function* addGreetingCardIsle(action) {
    try {
        const greetingData = action.greetingData;
        const featureFlags = yield select(getFeatureFlags);
        const cardIsleSelected = greetingData.data;
        const brandCode = greetingData.brandCode;
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);

        let skuCI = cardIsleSelected.productCode;
        if (skuCI?.indexOf('-') >= 0) {
            skuCI = skuCI.split('-');
            skuCI = skuCI[skuCI.length - 1];
        }

        yield put(clearOrderItemErrors(
            cartId,
            'payment',
            { errType: 'clearAllFields', field: '' },
        ));

        // Save Card isle
        const payload = {
            env: {},
            jwtToken,
            cartItemId: action.orderItemId,
            brandCode,
            sku: skuCI, // card isle product code
            greetingCardKey: cardIsleSelected.pickupCode,
            greetingMessage: cardIsleSelected.textMessage || ' ',
            greetingCardName: cardIsleSelected.name,
            greetingCardImage: cardIsleSelected.img,
            greetingCardType: 'CI',
            greetingThumbNail: cardIsleSelected.img || '',
            cartId,
        };

        const priceRulesFromABTest = greetingData?.data?.priceRules || null;
        if (priceRulesFromABTest?.length > 0) {
            payload.priceRules = priceRulesFromABTest;
        }

        const priceRules = yield call(getLoyaltyPriceRules, cardIsleSelected.productCode, brandCode);

        if (priceRules?.length > 0) {
            payload.priceRules = priceRules;
        }

        const responseGreeting = yield call(cartServiceClient.addGreetingCard, payload);

        if (responseGreeting?.data?.result === 'SUCCESS') {
            yield fork(sendGreetingCardDataToCardIsle, action);

            if (action.hasCallBack) {
                if (!action?.data?.isRecipientData) {
                    yield call(prepareRetreiveCart, action?.pageType);
                    yield call(retrieveCart);
                }
                yield call(action.handleCallBack, false);
            }
        }

        // Tagging for save cardisle
        yield put(trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Card Isle',
            eventLabel: `Card Isle | ${cardIsleSelected.name}`,
        }));

        if (
            featureFlags['is-loyalty-greeting-card-enabled']
            && payload.priceRules
        ) {
            // Tagging for loyalty personalized card
            yield put(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Add to cart',
                eventLabel: 'Personalized Card - Giftastic',
            }));
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'CardIsle-Operation',
            function: 'loadCardIsleAvailable',
            jsError: ex,
            message: 'Failed in adding enterprise Card Isle to Cart',
        });
        yield put(loadError({
            errType: 'cardIsle',
            errMsg: 'We are sorry, there seems to be a technical issue with cardIsle payment method, please try again later or use alternate payment method to complete order',
        }));

        yield put(callHandleCartFailure(ex));

        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action.orderItemId,
                errorFeatureType: 'giftMessage',
                errorValues: ex.response?.data,
            },
        });
    }
    yield put(addCardIsleComplete());
}

const watchers = [
    fork(loadCardIsleAvailableWatcher),
    fork(addCardIsleToCartWatcher),
    fork(enterpriseAddCardIsleToCartWatcher),
];

export {
    watchers,
    loadCardIsleAvailable,
    addCardIsleToCart,
    addGreetingCardIsle,
    getLoyaltyPriceRules,
};

export default {};
